import src from "IMAGE";
export default { src, width: 400, height: 336, blurWidth: 0, blurHeight: 0};
